// ============================================================
//  SERVICE WORKER REGISTRATION
//  Enregistre /service-worker.js au démarrage de l'app.
//  Adapté du template officiel Create React App.
//
//  En localhost : vérifie que le SW existe avant de l'enregistrer
//  (utile en dev pour éviter les erreurs).
//  En prod : enregistre directement.
// ============================================================

const isLocalhost = Boolean(
  typeof window !== "undefined" && (
    window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(/^127(?:\.(?:\d+)){3}$/)
  )
);

export function register(config) {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  // Empêche l'enregistrement si l'app est servie depuis un origin différent du SW.
  const publicUrl = new URL(
    process.env.PUBLIC_URL || "",
    window.location.href
  );
  if (publicUrl.origin !== window.location.origin) return;

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;
    if (isLocalhost) {
      checkValidServiceWorker(swUrl, config);
      navigator.serviceWorker.ready.then(() => {
        console.log("[SW] App served by service worker (localhost).");
      });
    } else {
      registerValidSW(swUrl, config);
    }
  });
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;
        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              // Nouvelle version dispo, activable au prochain reload.
              console.log("[SW] New content available; it will be used on next reload.");
              if (config && config.onUpdate) config.onUpdate(registration);
            } else {
              // Tout le contenu est cached pour utilisation offline.
              console.log("[SW] Content cached for offline use.");
              if (config && config.onSuccess) config.onSuccess(registration);
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error("[SW] Registration failed:", error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { "Service-Worker": "script" } })
    .then((response) => {
      const contentType = response.headers.get("content-type");
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf("javascript") === -1)
      ) {
        // Pas de SW trouvé. Probablement une app différente — désinstalle.
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => window.location.reload());
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log("[SW] No internet connection. App running in offline mode.");
    });
}

export function unregister() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch((error) => console.error(error.message));
}
